import crypto from "crypto-js";

function parseURLParams() {
  const params = new URLSearchParams(window.location.search);

  const showId = params.get("showId");
  const companyId = params.get("companyId");
  const standId = params.get("standId");
  const taskId = params.get("taskId");
  const reviewer = params.get("reviewer");
  const key = params.get("key");

  // Magic-links carry only key + showId; decrypt reviewer only if
  // present — null crashes crypto-js.
  const saltKey = import.meta.env.VITE_EMAIL_SALT as string;
  let decodedReviewer = "";
  if (reviewer) {
    try {
      const bytes = crypto.AES.decrypt(reviewer, saltKey);
      decodedReviewer = bytes.toString(crypto.enc.Utf8);
    } catch {
      decodedReviewer = "";
    }
  }

  return {
    showId,
    companyId,
    standId,
    taskId,
    reviewer: decodedReviewer,
    unparsedReviewer: reviewer,
    key,
  } as const;
}

export default parseURLParams;
